import { Component, EventEmitter, Input, Output } from "@angular/core"
import { Media } from "../../../models/resource/media"

@Component({
    selector: "app-language-selector",
    templateUrl: "./language-selector.component.html",
    styleUrls: ["./language-selector.component.less"],
})
export class LanguageSelectorComponent {
    @Input() public items: Media[] = []
    @Input() public selectedItem: any
    @Output() public selectedItemChange = new EventEmitter<any>()
}
